import { render, staticRenderFns } from "./betterRefresh.vue?vue&type=template&id=00aee33a&scoped=true&"
import script from "./betterRefresh.vue?vue&type=script&lang=js&"
export * from "./betterRefresh.vue?vue&type=script&lang=js&"
import style0 from "./betterRefresh.vue?vue&type=style&index=0&id=00aee33a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aee33a",
  null
  
)

export default component.exports